import axios from "axios";
import callPiggybackAPI from "./piggyback.api.helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";

export const ImportButtonHelper = (
  selectedSite,
  setSelectedFile,
  setIsImportModalOpen,
  setDataRecords,
  enqueueSnackbar,
  truInkState,
  selectedFile,
  setSelectedDataInfoId,
  setOpen,
  selectedSiteOption,
  selectedDataInfoId,
  onSaveSuccess,
  gatewaysSchema,
  digitalTagsSchema,
  dataRecordSchema,
  setFormData,
  setFormTitle,
  setCurrentSchema,
  setSchemaModalOpen,
  setIsAddCollectionModal,
  setIsTruInkEMMSModalOpen
) => {
  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleImportFile = async () => {
    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }

    if (!truInkState.dataInfoId) {
    }
    let dataInfoList = null;
    try {
      dataInfoList = await callPiggybackAPI(
        "data-info",
        { tenantId: selectedSite.tenantId, siteId: selectedSite.id },
        {},
        "GET"
      );
      if (dataInfoList && Array.isArray(dataInfoList)) {
        setSelectedDataInfoId(dataInfoList[0].id);
      } else {
        setSelectedDataInfoId(null);
      }
    } catch (error) {
      console.error("Failed to fetch data-info", error);
      setSelectedDataInfoId(null);
    }

    try {
      let formData = new FormData();
      formData.append("file", selectedFile);
      const api = localStorage.getItem("api");
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      };
      const requestBody = {
        path: "data-record/import",
        query: {
          tenantId: selectedSite.tenantId,
          siteId: selectedSite.id,
          dataInfoId: dataInfoList[0].id,
        },
        requestType: "POST",
        headers: headers,
      };
      formData.append("jsonData", JSON.stringify(requestBody));
      const response = await axios.post(
        `${api}/truink/piggyback/formData`,
        formData,
        {
          headers,
        }
      );
      toast.success("Uploaded Sucessfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error("Import error:", error);
      toast.error("Error uploading file", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }

    setIsImportModalOpen(false);
  };

  const fetchDataRecords = async () => {
    if (!selectedSite) return;

    try {
      const apiResponse = await callPiggybackAPI(
        "data-record",
        { siteId: selectedSite.id, tenantId: selectedSite.tenantId },
        {},
        "GET"
      );

      if (Array.isArray(apiResponse)) {
        const normalizedData = apiResponse.map((item, index) => ({
          id: item.id || `row-${index}`,
          identifier: item.identifier,
          dataInfoId: item.dataInfoId,
          ...item.values,
        }));
        setDataRecords(normalizedData);
        return normalizedData;
      } else {
        setDataRecords([]);
        return [];
      }
    } catch (err) {
      console.error("Failed to fetch data records:", err);
      setDataRecords([]);
      return [];
    }
  };
  const handleSave = async (updatedData) => {
    let body = {};
    let path = "";

    if (!selectedSite) {
      console.error("No site is selected. Cannot save data.");
      setOpen(false);
      return;
    }

    switch (selectedSiteOption) {
      case "SiteData":
        path = "data-record";

        const values = Object.keys(updatedData).reduce((acc, key) => {
          if (key === "identifier") return acc;

          acc[key] = updatedData[key];

          return acc;
        }, {});
        body = {
          tenantId: selectedSite.tenantId,
          siteId: selectedSite.id,
          dataInfoId: selectedDataInfoId,
          values,
          identifier: updatedData.identifier,
          recordedAt: new Date().toISOString(),
          customProperties: {},
        };
        break;
      case "Gateways":
        path = "gateways";
        body = {
          siteId: selectedSite.id,
          tenantId: selectedSite.tenantId,
          ...updatedData,
        };
        break;
    
      case "Digital Tags":
        path = "digitalTag";
        body = {
          tenantId: selectedSite.tenantId,
          siteId: selectedSite.id,
          name: updatedData.name,
          macAddress: updatedData.macAddress,
          canvasSizeId: updatedData.canvasSizeId,
          canvasColorId: updatedData.canvasColorId,
          customProperties:{
            rotation: updatedData.rotation
          }
        };
        break;
      case "Collections":
        path = "collections";
        body = {
          tenantId: selectedSite.tenantId,
          siteId: selectedSite.id,
          name: updatedData.name,
          dataIds: updatedData.items.map((item) => item.id),
        };
        break;
      default:
        console.error("Unknown selected option. Cannot save data.");
        setOpen(false);
        return;
    }

    try {
      const apiResponse = await callPiggybackAPI(path, {}, body, "POST");
      if (apiResponse) {
        if (onSaveSuccess) onSaveSuccess();
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }

    setOpen(false);
  };

  const handleDownload = async (type) => {
    try {
      if (!selectedSite) {
        console.warn("No site selected");
        return;
      }

      const dataInfoList = await callPiggybackAPI(
        "data-info",
        { tenantId: selectedSite.tenantId, siteId: selectedSite.id },
        {},
        "GET"
      );

      if (!Array.isArray(dataInfoList) || dataInfoList.length === 0) {
        toast.warn("No data-info found", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return;
      }

      const dataInfo = dataInfoList[0];
      const fields = dataInfo.fields;

      if (!fields || Object.keys(fields).length === 0) {
        toast.warn("This data-info has no fields defined", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return;
      }

      const includeLabels = "labels" in fields;
      const headers = [...Object.keys(fields), ...(includeLabels ? ["labels"] : [])];

      const getSampleValue = (key) => {
        if (key === "labels") return "label1, label2";
        if (key === "allergens") return "Dairy, Gluten";
        if (Array.isArray(fields[key])) return "value1, value2";
        return `Sample ${key}`;
      };
      const sampleRow = headers.map(getSampleValue);

      if (type === "csv") {
        const csvRow = headers.map((key) => {
          const val = getSampleValue(key);
          return val.includes(",") ? `"${val}"` : val;
        });
        const csvContent =
          headers.join(",") + "\n" + csvRow.join(",") + "\n";
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${dataInfo.name || "data-info"}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Template CSV downloaded", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }

      if (type === "excel") {
        const ws = XLSX.utils.aoa_to_sheet([headers, sampleRow]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Template");
        XLSX.writeFile(wb, `${dataInfo.name || "data-info"}.xlsx`);
        toast.success("Template Excel downloaded", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error creating template:", error);
      toast.error("Failed to download template", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };


  const handleDownloadDigitalTagsSample = async (type) => {
  try {
    const headers = [
      "name",
      "macAddress",
      "rotation",
    ];

    const sampleRow = [
      "Sample Tag",
      "e00000000000",
      "180",
    ];

    if (type === "csv") {
      const csvContent =
        headers.join(",") + "\n" + sampleRow.join(",") + "\n";

      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "digital-tags-template.csv");

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Template CSV downloaded", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }

    if (type === "excel") {
      const ws = XLSX.utils.aoa_to_sheet([
        headers,
        sampleRow,
      ]);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Digital Tags");

      XLSX.writeFile(wb, "digital-tags-template.xlsx");

      toast.success("Template Excel downloaded", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  } catch (error) {
    console.error("Error creating template:", error);

    toast.error("Failed to download template", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  }
};

const handleImportDigitalTags = async (setBulkImportTagResult,setBulkImportTagResultModalOpen) => {
  if (!selectedFile) {
    alert("Please select a file first.");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("file", selectedFile);

    const api = localStorage.getItem("api");
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    };

    const requestBody = {
      path: "digitalTag/bulkAddImport",
      query: {
        tenantId: selectedSite.tenantId,
        siteId: selectedSite.id,
      },
      requestType: "POST",
      headers,
    };

    formData.append(
      "jsonData",
      JSON.stringify(requestBody)
    );

    const response = await axios.post(
      `${api}/truink/piggyback/formData`,
      formData,
      {
        headers,
      }
    );

    if(response?.data?.message){
       toast.error(response?.data?.message, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    setIsImportModalOpen(false);
    setBulkImportTagResult({})
    setBulkImportTagResultModalOpen(false)
    return null
    }

    setBulkImportTagResult(response?.data)
    setBulkImportTagResultModalOpen(true)
    

  } catch (error) {
    console.error("Digital Tag Import Error:", error);

    toast.error("Error importing digital tags", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  }

  setIsImportModalOpen(false);
};

  const handleOpenModal = async () => {
    if (selectedSiteOption === "Collections") {
      const records = await fetchDataRecords();
      setIsAddCollectionModal(true);
      return;
    }

    let schema = {};
    let title = "";

    switch (selectedSiteOption) {
      case "SiteData":
        title = "Add Site Data";
        try {
          const dataInfoList = await callPiggybackAPI(
            "data-info",
            { tenantId: selectedSite.tenantId, siteId: selectedSite.id },
            {},
            "GET"
          );
          if (dataInfoList && Array.isArray(dataInfoList)) {
            setSelectedDataInfoId(dataInfoList[0].id);
          } else {
            setSelectedDataInfoId(null);
          }
          const includeLabels = "labels" in (dataInfoList[0].fields || {});
          schema = { ...dataRecordSchema(dataInfoList[0].fields, includeLabels) };
        } catch (error) {
          console.error("Failed to fetch data-info", error);
          setSelectedDataInfoId(null);
        }
        break;
    
      case "Gateways":
        schema = { ...gatewaysSchema };
        title = "Add Gateway";
        try {
          const queues = await callPiggybackAPI("queue", {}, {}, "GET");
          if (queues && Array.isArray(queues)) {
            schema.queue.options = queues.map((q) => ({
              value: q.id,
              label: q.name,
            }));
          } else {
            schema.queue.options = [];
          }
        } catch (error) {
          console.error("Failed to fetch queues", error);
          schema.queue.options = [];
        }
        break;
      case "Digital Tags":
        schema = digitalTagsSchema;
        title = "Add Digital Tag";
        break;
      case "StoreSettings":
        setSchemaModalOpen(true);
        return;
      case "TruInk EMMS":
        setIsTruInkEMMSModalOpen(true);
        return;
      default:
        console.error(`Schema not found for option: ${selectedSiteOption}`);
        return;
    }

    const initialData = Object.keys(schema).reduce((acc, key) => {
      acc[key] = schema[key].initialValue;
      return acc;
    }, {});

    setFormData(initialData);
    setFormTitle(title);
    setCurrentSchema(schema);
    setOpen(true);
  };
  return {
    handleFileChange,
    handleImportFile,
    fetchDataRecords,
    handleSave,
    handleDownload,
    handleOpenModal,
    handleDownloadDigitalTagsSample,
    handleImportDigitalTags
  };
};
